const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/LabelLink.tsx';
import * as React from 'react';
import { TextInput, useText } from '@cistec/common_web/utils/intlUtils';
import { css } from '@emotion/css';
import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material';

// stop propagation in order to prevent things like a checkbox being checked
// by clicking on its label (when this link is part of the label)
const handleClick = (event: any) => {
    event.stopPropagation();
};

export const labelLinksStyle = (theme: Theme) => css`
    & > a {
        text-decoration: none;
        cursor: pointer;
        color: ${theme.palette.primary.main};
    }
`;

type Props = {
    url: string;
    text: TextInput;
};

export const LabelLink = (props: Props) => {
    const theme = useTheme();
    const text = useText(props.text);

    return (
        <span onClick={handleClick} className={labelLinksStyle(theme)}>
            <a target="_blank" rel="noreferrer" href={props.url}>
                {text}
            </a>
        </span>
    );
};

LabelLink.displayName = 'LabelLink';
